<template>
    <div :class="fontSize == 2 ? 'fontResize' : fontSize == 1 ? 'fontResize titleSmall' : 'fontResize titleBig'">
        <text>字体：</text>
        <a :class="fontSize == 1 ? 'selected fontStyle' : 'fontStyle'" @click="toResize(1)">小</a>
        <a :class="fontSize == 2 ? 'selected fontStyle middle' : 'fontStyle middle'" @click="toResize(2)">中</a>
        <a :class="fontSize == 3 ? 'selected fontStyle' : 'fontStyle'" @click="toResize(3)">大</a>
    </div>
</template>
<script>
import store from '@/store';
import { onMounted, watch, ref } from 'vue';
export default {
    name: 'Font',
    emits:['setOffsetTop'],
    setup(props,ctx) {
        watch(() => store.getters.fontSize, (val) => {
            fontSize.value = val
            ctx.emit('setOffsetTop')
        })
        onMounted(() => {
            fontSize.value = store.getters.fontSize
         
        })
        const fontSize = ref('')
        const toResize = (val) => {
            store.dispatch('fontSize', val)
        }
        return {
            toResize,
            fontSize
        }
    }
}
</script>
<style lang="less" scoped>
.fontResize.titleBig {
    font-size: 15px;
}

.fontResize.titleSmall {
    font-size: 11px;
}

.fontResize {
    margin: 0 20px 5px 20px;
    font-size: 13px;
    text-align: right;

    a {
        color: rgb(89, 89, 89);
    }

    a:hover {
        color: #315efb !important;
    }

    .selected {
        color: red
    }

    .middle {
        margin: 0 0.5rem;
    }

    .fontStyle {
        text-decoration: underline
    }
}</style>
